<template>
  <section class="bg-[#EBEBEB] flex flex-col w-full items-center">
    <div
      class="flex flex-col gap-[33px] pb-[66px] xl:w-[828px] lg:px-[102px] items-center lg:justify-between xl:px-0 px-[32px] lg:pb-[75px]">

      <div class="section-header-container">
        <h4 class="section-header-1">FAQ</h4>
        <h3 class="section-header-2">Perguntas Frequentes</h3>
      </div>

      <ul class="flex flex-col gap-[12px]">
        <li v-for="(ask, index) in questions" :key="index"
          class="flex flex-col border border-[#D9D9D9] rounded-[8px] cursor-pointer">

          <div @click="toggle(ask)" class="flex justify-between px-[20px] py-[10px] items-center lg:px-[47px]">
            <h3 class="text-[20px]" v-text="ask.question"></h3>
            <img class="rotate-90 w-[13px] h-[22px] transition-all ease-linear" :class="ask.open ? '-rotate-90' : ''"
              src="/img/icons/arrow-right.svg" alt="Banner" />
          </div>

          <div
            class="px-[18px] bg-[#D9D9D9] rounded-b-[8px] overflow-hidden transition-all ease-linear lg:px-[47px] flex flex-col gap-[12px]"
            :class="ask.open ? 'h-auto py-[20px]' : 'h-0'">
            <span class="text-left leading-[147%]" v-html="ask.response"></span>
            <div v-if="ask.blogLink" class="flex flex-row gap-[10px]">
              <span class="font-semibold">Leia mais em:</span>
              <a :href="ask.blogLink" target="_blank" rel="nofollow"
                class="text-[#2990E5] font-semibold border-none hover:text-[--yellow] p-[0!important] cursor-pointer">
                {{ ask.blogLabel }}
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>

export default {
  name: "FaqSection",
  data() {
    return {
      questions: [
        {
          open: true,
          question: "O que é antecipação do FGTS?",
          response: "A antecipação do FGTS é uma <strong>modalidade de crédito</strong> que permite ao trabalhador antecipar o recebimento do saque-aniversário do FGTS. Com essa modalidade, você recebe um valor agora e o pagamento é descontado diretamente do seu saldo de FGTS a cada aniversário, sem comprometer seu salário mensal. Por ser uma operação de crédito, incidem <strong>juros e IOF</strong> sobre o valor contratado.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
        {
          open: false,
          question: "Quais são os encargos cobrados? Há juros e IOF?",
          response: "Sim. Por se tratar de uma operação de crédito, há incidência de <strong>juros</strong> (taxa de juros definida pela instituição financeira parceira) e <strong>IOF (Imposto sobre Operações Financeiras)</strong>, conforme legislação vigente. Todos os encargos são apresentados de forma clara e transparente no momento da simulação e antes da assinatura do contrato. O Custo Efetivo Total (CET) da operação é informado antes da contratação.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
        {
          open: false,
          question: "Qual é o prazo máximo para pagamento?",
          response: "O prazo máximo para pagamento da antecipação do FGTS é de até <strong>5 anos (60 meses)</strong>. As parcelas são descontadas automaticamente da sua conta de FGTS no mês do seu aniversário, a cada ano. Isso significa que você não paga nada do seu bolso mensalmente — o desconto ocorre diretamente no saldo do FGTS.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
        {
          open: false,
          question: "Como funciona o desconto das parcelas?",
          response: "O desconto é feito <strong>automaticamente no saldo da sua conta de FGTS</strong> no mês do seu aniversário, ano a ano, até a quitação total do crédito. Você não precisa pagar boletos, não há desconto em folha de pagamento e não há débito automático em conta corrente. O saldo do FGTS é utilizado como garantia e forma de pagamento da operação.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
        {
          open: false,
          question: "Quem pode solicitar esse serviço?",
          response: "Trabalhadores com carteira assinada, que optaram pela modalidade saque-aniversário, possuem saldo no FGTS e estão adimplentes podem solicitar a antecipação. É necessário ter mais de 18 anos e conta bancária em seu nome.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
        {
          open: false,
          question: "Como funciona o processo de antecipação?",
          response: "O processo é ágil e seguro: você faz a simulação, recebe todas as informações sobre taxas, IOF, prazo e CET, assina o contrato digitalmente e o valor é liberado em sua conta conforme o prazo informado na contratação. Toda a operação é 100% online e transparente.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
        {
          open: false,
          question: "Preciso pagar algum valor antecipado para contratar?",
          response: "Não. O cliente <strong>não precisa desembolsar nenhum valor prévio</strong> para solicitar o serviço. Os encargos (juros e IOF) são descontados do próprio crédito contratado. Desconfie de qualquer solicitação de pagamento antecipado — isso não faz parte do processo legítimo de antecipação de FGTS.",
          blogLink: "https://blog.vipfinanceira.com.br/busca?q=fgts",
          blogLabel: 'blog.com/fgts',
        },
      ]
    }
  },
  props: {
    originTag: String
  },
  methods: {
    toggle(ask) {
      if (ask.open === true) {
        this.questions.forEach((question) => (question.open = false))
      } else {
        this.questions.forEach((question) => (question.open = false))
        ask.open = !ask.open
      }
    }
  }
}
</script>
